import { Invitation } from "@api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReactQueryConfig } from "@helpers/types";
import useApi from "@helpers/hooks/useApi";
import { ListResponse } from "./queryUtils";

interface ListProps {
  limit?: number;
  offset?: number;
}

export function useInvitationsList({
  limit,
  offset,
}: ListProps): UseQueryResult<
  ListResponse<Invitation>,
  AxiosError["response"]
> {
  const api = useApi();

  return useQuery({
    queryKey: ["invitations/list", { limit, offset }],
    queryFn: async () => {
      const res = await api.apiV1InvitationsList(limit, offset);
      return res.data;
    },
  });
}

interface DetailProps {
  token: string;
}

export function useInvitation(
  { token }: DetailProps,
  config?: ReactQueryConfig,
): UseQueryResult<Invitation, AxiosError["response"]> {
  const api = useApi();

  return useQuery({
    queryKey: ["invitations/detail", { token }],
    queryFn: async () => {
      const res = await api.apiV1InvitationsRead(token);
      return res.data;
    },
    enabled: config?.enabled !== false,
  });
}
